import { post } from './http'

//日锻炼人数
export function getDayCollegeRunInfo(date) {
  return post('/tyapi/pc/cockpit/getDayCollegeRunInfo', {
    date: date,
  })
}

//日锻炼总数
export function getDayRunNum(date) {
  return post('/tyapi/pc/cockpit/getDayRunNum', {
    date: date,
  })
}

//周锻炼人次
export function getWeekCollegeRunInfo(date) {
  return post('/tyapi/pc/cockpit/getWeekCollegeRunInfo', {
    date: date,
  })
}

//月锻炼人次
export function getMonthCollegeRunInfo(date) {
  return post('/tyapi/pc/cockpit/getMonthCollegeRunInfo', {
    date: date,
  })
}

//获取24小时跑步情况列表
export function getOndDayRunInfo(date) {
  return post('/tyapi/pc/cockpit/getOndDayRunInfo', {
    date: date,
  })
}

//getLastDayRunInfo
export function getLastDayRunInfo() {
  return post('/tyapi/pc/cockpit/getLastDayRunInfo', {})
}

//获取累计跑步情况列表
export function getAllRunInfo() {
  return post('/tyapi/pc/cockpit/getAllRunInfo', {})
}

//getToDayRunInfo
export function getToDayRunInfo(date) {
  return post('/tyapi/pc/cockpit/getToDayRunInfo', {
    date: date,
  })
}

//获取场地跑步情况列表
export function getVenueRunInfo() {
  //   return post('/tyapi/pc/cockpit/getVenueRunInfo', {
  //     "venueIds" : "1,3"
  //   })
  return post('/tyapi/pc/cockpit/getVenueRunInfo', {})
}

//获取学期跑步情况列表
//export function getTermRunInfo() {
//return post('/tyapi/pc/cockpit/getTermRunInfo', {})
//}

export function warningExercise() {
  return post('/tyapi/pc/cockpit/warningExercise', {})
}
//根据场地获取跑步情况列表
export function getRunInfoByVenueId(venueId) {
  return post('/tyapi/pc/cockpit/getRunInfoByVenueId', {
    venueId: venueId,
  })
}

export function getEntranceByVenueId(venueId) {
  return post('/tyapi/pc/cockpit/getEntranceByVenueId', {
    venueId: venueId,
  })
}
//获取学期跑步情况列表-新
export function getTermRunInfo() {
  return post('/tyapi/pc/cockpit/getTermRunInfo', {})
}

//根据场地获取近七天各分院锻炼人次列表
export function getWeekExerciseNum(venueId, date) {
  return post('/tyapi/pc/cockpit/getWeekExerciseNum', {
    venueId: venueId,
    date: date,
  })
}

//根据场地获取本学期各分院锻炼人次列表
export function getTermExerciseNum(venueId) {
  return post('/tyapi/pc/cockpit/getTermExerciseNum', {
    venueId: venueId,
  })
}

//根据场地获取昨日各分院锻炼人次列表
export function getLastDayExerciseNum(venueId, date) {
  return post('/tyapi/pc/cockpit/getLastDayExerciseNum', {
    venueId: venueId,
    date: date,
  })
}

//根据场地本月锻炼人次
export function getMonthExerciseNum(venueId, date) {
  return post('/tyapi/pc/cockpit/getMonthExerciseNum', {
    venueId: venueId,
    date: date,
  })
}

//根据场地24小时活跃度
export function getOndDayExerciseByVenueId(venueId, date) {
  return post('/tyapi/pc/cockpit/getOndDayExerciseByVenueId', {
    venueId: venueId,
    date: date,
  })
}
